const stylesheet = new CSSStyleSheet();stylesheet.replaceSync(`a {
  color: var(--text);
}
`);export default stylesheet;